import { BasicSearch, MobileSearch } from '@/components/Search';
import Media from 'react-media';
import { BasicSearchWrapper } from './styled';
import { useTheme } from '@simplywallst/ui-core';
import type { CustomPeers } from '../../../../../../query';
import { useEffect, useState } from 'react';
import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

type Props = {
  index: number;
  peer: CustomPeers[number];
  selectingPeers: CustomPeers;
  uniqueSymbol: string;
  isError: boolean;
  onError: (index: number, isError: boolean) => void;
  onSelectPeer: (index: number, newPeer: CustomPeers[number]) => void;
  onResetPeer: (index: number) => void;
};

export const PeerSearch = ({
  index,
  peer,
  selectingPeers,
  isError,
  uniqueSymbol,
  onError,
  onSelectPeer,
  onResetPeer,
}: Props) => {
  const theme = useTheme();
  const [errorMsg, setErrorMsg] = useState('');
  const t = useValuationTranslation();

  useEffect(() => {
    if (!isError) setErrorMsg('');
  }, [isError]);

  const setValidCustomPeer = (newPeer: CustomPeers[number]) => {
    const peerFound = selectingPeers.find(
      (currentPeer) => currentPeer.id === newPeer.id
    );
    if (peerFound) {
      setErrorMsg(t('vsPeers.customPeers.error.duplicate'));
      onError(index, true);
      return newPeer;
    }
    if (newPeer.id === uniqueSymbol) {
      setErrorMsg(t('vsPeers.customPeers.error.existing'));
      onError(index, true);
      return newPeer;
    }
    setErrorMsg('');
    onError(index, false);
    return newPeer;
  };
  const handleSelectPeer = (index: number, newPeer: CustomPeers[number]) => {
    const validPeer = setValidCustomPeer(newPeer);
    onSelectPeer(index, validPeer);
  };
  const handleResetPeer = (index: number, value: string) => {
    if (value === '') {
      setErrorMsg(t('vsPeers.customPeers.error.required'));
      onResetPeer(index);
      onError(index, true);
    }
  };

  return (
    <BasicSearchWrapper addMargin={errorMsg !== ''} key={peer.id}>
      <Media query={{ maxWidth: theme.mdMaxRaw }}>
        {(match) => {
          if (match) {
            return (
              <MobileSearch
                name={peer.name}
                value={peer.name}
                theme="light"
                error={errorMsg}
                onReset={() => handleResetPeer(index, '')}
                onClick={(newPeer) => {
                  handleSelectPeer(index, newPeer);
                }}
              />
            );
          }
          return (
            <BasicSearch
              name={peer.name}
              value={peer.name}
              theme="light"
              onReset={() => handleResetPeer(index, '')}
              //TODO: @riccarb refactor onClick to return company name and remove onSelectCompany
              onSelectCompany={(newPeer) => {
                handleSelectPeer(index, newPeer);
              }}
              error={errorMsg}
              onBlur={(value) => handleResetPeer(index, value)}
            />
          );
        }}
      </Media>
    </BasicSearchWrapper>
  );
};
